/**
 * As 4 áreas da equipe do Secretário. Quem fala com a pessoa é o Secretário
 * que ela escolheu; por trás dele, 4 personagens de área cuidam de grupos de
 * habilidades e assinam os serviços prontos e as falas da Reunião.
 * Habilidade é objeto (sem rosto); personagem é só o Secretário e estes 4.
 */
export const AREA_KEYS = ['dinheiro', 'rotina', 'informacao', 'trabalho'];
export const AREA_CATALOG = [
    {
        key: 'dinheiro',
        name: 'Dinheiro',
        tagline: 'Contas, preços e impostos',
        character: { key: 'area-conty', name: 'Dinheiro' },
        tone: 'mint',
        specialists: ['contas', 'radar_precos', 'mercado'],
        services: ['raio_x', 'assinaturas', 'irpf', 'mei', 'fecho'],
    },
    {
        key: 'rotina',
        name: 'Rotina',
        tagline: 'Agenda, compras e datas',
        character: { key: 'area-zeca', name: 'Rotina' },
        tone: 'peach',
        specialists: ['bom_dia', 'clima', 'lista_compras', 'datas_importantes', 'passagens'],
        services: ['segunda', 'viagem', 'festa', 'estudos'],
    },
    {
        key: 'informacao',
        name: 'Informação',
        tagline: 'Notícias e resumos',
        character: { key: 'area-manchete', name: 'Informação' },
        tone: 'lilac',
        specialists: ['noticias', 'resumo_grupos', 'retrospectiva', 'horoscopo'],
        services: ['dossie', 'semana'],
    },
    {
        key: 'trabalho',
        name: 'Trabalho',
        tagline: 'Clientes, cartas e carreira',
        character: { key: 'area-rumo', name: 'Trabalho' },
        tone: 'toon',
        specialists: [],
        services: ['carta', 'carreira'],
    },
];
export function findArea(key) {
    return AREA_CATALOG.find((area) => area.key === key);
}
/** Área de uma habilidade (especialista). */
export function areaOfSpecialist(key) {
    return AREA_CATALOG.find((area) => area.specialists.includes(key));
}
/** Área de um serviço pronto. */
export function areaOfService(key) {
    return AREA_CATALOG.find((area) => area.services.includes(key));
}
/**
 * Quem fala na Reunião: a área. Reuniões antigas guardaram a chave do
 * especialista; elas são lidas como a área dele.
 */
export function meetingArea(speaker) {
    if (!speaker)
        return undefined;
    return findArea(speaker) ?? areaOfSpecialist(speaker);
}
